import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Container, InputSearch } from './style';
import Icon from '../Icon';

const SearchBar = ({
  placeholder,
  value,
  onChange,
  onSubmit,
  onClickClose,
  closeAlwaysVisible = false,
  forceFocus = false,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (forceFocus) inputRef.current?.focus();
  }, [forceFocus]);

  return (
    <form onSubmit={onSubmit} role="search">
      <Container>
        <span className="visually-hidden">Cerca</span>
        <Icon type="search-sm" onClick={onSubmit} />
        <InputSearch
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          ref={inputRef}
          type="search"
        />
        {(value?.length > 0 || closeAlwaysVisible) && (
          <Icon type="x" onClick={onClickClose} />
        )}
      </Container>
    </form>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClickClose: PropTypes.func,
  closeAlwaysVisible: PropTypes.bool,
  forceFocus: PropTypes.bool,
};

export default SearchBar;
